import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import Publish from 'app/Publish/components/Publish';

const compassMessage =
  'This is a Compass page. To schedule a publish, Publish Live Now then schedule in Compass.';
const livePageMessage = 'Changes made to currently live page cannot be scheduled.';

/**
 * This component is a redux connected component.
 * This component creates a button on UI and is the starting point of page publish event.
 * It shows the modal to setup publsh page and eventually publishes the page as per the user inputs.
 */
export default class PublishPage extends Component {
  static propTypes = {
    headerText: propTypes.string,
    isOpen: propTypes.bool,
    message: propTypes.string,
    modalToggle: propTypes.func.isRequired,
    onPublishPage: propTypes.func.isRequired,
    pagePayload: propTypes.shape(),
    publishDate: propTypes.string,
    publishNowButtonText: propTypes.string,
    scheduleButtonText: propTypes.string,
    isCompassPage: propTypes.bool,
    isTestContent: propTypes.bool
  };

  static defaultProps = {
    headerText: 'Publish Page',
    isOpen: false,
    message: undefined,
    pagePayload: null,
    publishDate: undefined,
    publishNowButtonText: undefined,
    scheduleButtonText: undefined,
    isCompassPage: false,
    isTestContent: false
  };

  constructor(props) {
    super(props);

    this.onPublish = this.onPublish.bind(this);
  }

  /**
   * toggles the publish page modal and calls the onPublish callback
   * @param {boolean} publishNow - publish true/false
   * @param {string} publishDate - UTC date time of publish
   * @param {boolean} isTestContent - whether page is published for testing purposes only
   */
  onPublish(publishNow, publishDate, isTestContent) {
    this.props.onPublishPage(this.props.pagePayload, publishNow, publishDate, isTestContent);
  }

  render() {
    const {
      headerText,
      isOpen,
      message,
      modalToggle,
      pagePayload,
      publishDate,
      publishNowButtonText,
      scheduleButtonText,
      isCompassPage,
      isTestContent
    } = this.props;
    const wcmMessage = pagePayload.LiveNow ? `${message || ''} ${livePageMessage}` : message;
    const enabledRouteURLs = pagePayload?.Payload?.MetadataFields?.Route?.RouteMapping.filter(
      route => route.IsEnabled === 'Yes'
    ).map(route => route.RouteURL);

    return (
      <div>
        <Modal isOpen={isOpen} toggle={modalToggle}>
          <ModalHeader toggle={modalToggle} data-test-id="publish-cancelButton">
            {headerText}
          </ModalHeader>
          <ModalBody>
            <Publish
              showOnlyPublishNowButton={isCompassPage || pagePayload.LiveNow}
              message={isCompassPage ? compassMessage : wcmMessage}
              onPublish={this.onPublish}
              publishDate={publishDate}
              publishNowButtonText={publishNowButtonText}
              scheduleButtonText={scheduleButtonText}
              isTestContent={isTestContent}
              routes={enabledRouteURLs}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
